import { HeartStroke16, Heart16, Button } from '@cian/ui-kit';
import * as React from 'react';

export interface IDefaultFavoriteButtonNewProps {
  checked: boolean;
  onButtonClick(): void;
}

export const DefaultFavoriteButtonNew = ({ checked, onButtonClick }: IDefaultFavoriteButtonNewProps) => {
  return (
    <Button
      theme="stroke_secondary"
      beforeIcon={checked ? <Heart16 color="error_100" /> : <HeartStroke16 color="gray_icons_100" />}
      onClick={onButtonClick}
      size="XS"
    >
      {checked ? 'В избранном' : 'В избранное'}
    </Button>
  );
};
